//基本Account页面路由
export default {
    path: '/account',
    component: () => import('@/account/viewer.vue'),
    children: [
        {
            path: '',
            redirect: 'login'
        },
        {
            path: 'login',
            component: () => import(/* webpackChunkName: "Account-LOGIN" */ '@/account/views/login.vue'),
            meta: {
                title: '登陆'
            },
        },
        {
            path: 'signup',
            component: () => import(/* webpackChunkName: "Account-SIGNUP" */ '@/account/views/signup.vue'),
            meta: {
                title: '注册'
            },
        },
        {
            path: 'findpwd',
            component: () => import(/* webpackChunkName: "Account-FIND" */ '@/account/views/findpwd.vue'),
            meta: {
                title: '重置密码'
            },
        },
        {
            path: 'verify.php/:token?',
            component: () => import(/* webpackChunkName: "Account-VERIFY" */ '@/account/views/verify.vue'),
            meta: {
                title: '邮箱验证'
            },
        },
        {
            path: 'oauth.php/:service?',
            component: () => import(/* webpackChunkName: "Account-OAUTH" */ '@/account/views/oauth.vue'),
            meta: {
                title: 'OAUTH Service'
            },
        },
        {
            path: 'logout',
            component: () => import(/* webpackChunkName: "Account-LOGOUT" */ '@/account/views/logout.vue'),
            meta: {
                title: '$logout'
            },
        },
        {
            path: 'bind.php',
            component: () => import(/* webpackChunkName: "Account-BIND" */ '@/account/views/bind.vue'),
            meta: {
                title: '链接::第三方登陆服务'
            }
        }
    ]
}